import React from 'react';
import OrganizationInbox from 'screens/organizations/components/OrganizationInbox';
import { MemberOnlyOrganizationWrapper } from 'screens/organizations/context/EditOrganizationProvider';

const OrganizationInboxScreen = () => <OrganizationInbox />;

export default OrganizationInboxScreen;

OrganizationInboxScreen.getLayout = (page) => (
  <MemberOnlyOrganizationWrapper>{page}</MemberOnlyOrganizationWrapper>
);
